import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { DataTransactionActions } from "../actions/data-transaction.actions";
import { MpAdminActions } from "../actions/mp-admin.actions";
import { DataTransactionsState } from "../models/shared/data-transactions-state";

const initialState: DataTransactionsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(DataTransactionActions.dataTransactions.getApi, (state) =>
		_.merge(_.cloneDeep(state), { loading: true })
	),
	on(MpAdminActions.dataTransactions.getApi, (state) =>
		_.merge(_.cloneDeep(state), { loading: true })
	),
	on(DataTransactionActions.dataTransactions.getSuccess, (state, action) => merge(state, action)),
	on(MpAdminActions.dataTransactions.getSuccess, (state, action) => merge(state, action)),
	on(DataTransactionActions.dataTransactions.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	),
	on(MpAdminActions.dataTransactions.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

function merge(state: DataTransactionsState, action: Action): DataTransactionsState {
	const existingTransactions = [..._.get(state, "transactions", [])];
	const transactions = _.unionWith(
		existingTransactions,
		_.get(action, "transactions", []),
		_.isEqual
	);
	const existingSearchHistory = _.cloneDeep(_.get(state, "searchHistory", []));
	const searchHistory = _.unionWith(
		existingSearchHistory,
		_.get(action, "searchHistory", []),
		_.isEqual
	);
	return { transactions, searchHistory, loading: _.get(action, "loading", false) };
}

export function dataTransactionsReducer(
	state: DataTransactionsState | undefined,
	action: Action
): DataTransactionsState {
	return reducer(state, action);
}
